/* eslint-disable jsx-a11y/anchor-is-valid, import/namespace */
import PropTypes from "prop-types"
import React from "react"

// components
import Tooltip from "app/static/frontend/components/Tooltip"
import StyledSearchActionButtons from "app/static/frontend/search-new/components/FilterableListView/SearchActionButtons/StyledSearchActionButtons"
import {
    SearchCountInProfile,
    SearchProfileInput,
    ShowFilterSetButton,
} from "app/static/frontend/search-new/containers/FilterableListView/ActionButtons"
import { DropdownButton } from "quorumdesign"

// constants
import * as searchConstants from "app/static/frontend/search-new/constants"
import { LEADERSHIP_CONNECT_ORG_ID } from "shared/imports/sharedConstants"

import PayrollFormModal from "@/pages/campaign-form/components/donation-form/payroll-deduction-form-modal"

export default function SearchActionButtons(props) {
    const renderButton = (button) => {
        const ActionButton = button
        return (
            <ActionButton
                isProfile={props.isProfile}
                isOnlyTableView={props.isOnlyTableView}
                quorumDataType={props.quorumDataType}
                resource={props.resource}
                uniqueFlvId={props.uniqueFlvId}
            />
        )
    }

    const renderStyledButtonGroup = (group) => {
        const styledButtonGroup = (
            <DropdownButton
                dataCy={group.dataCy}
                isTiny
                leftIcon={group.fa5_icon}
                leftIconBreakpoint={
                    props.isProfile
                        ? searchConstants.PROFILE_HIDE_ICON_BREAKPOINT
                        : searchConstants.SEARCH_HIDE_ICON_BREAKPOINT
                }
                leftIconFamily={group.fa5_icon_family}
                leftIconSize="18px"
                // need this to ensure the icons are vertically centered
                leftIconStyle={{ display: "block" }}
                leftIconFixedWidth={false}
                menuOptionsChildren={group.buttons.map((button) => {
                    const ActionButton = button

                    return (
                        <ActionButton
                            isDropdownItem
                            isProfile={props.isProfile}
                            quorumDataType={props.quorumDataType}
                            resource={props.resource}
                            uniqueFlvId={props.uniqueFlvId}
                        />
                    )
                })}
                rightMargin="10px"
                text={group.label}
                textBreakpoint={
                    props.isProfile
                        ? searchConstants.PROFILE_HIDE_TEXT_BREAKPOINT
                        : searchConstants.SEARCH_HIDE_TEXT_BREAKPOINT
                }
                type={group.type || "outlined"}
            />
        )

        return group.tooltipText ? (
            <Tooltip label={group.tooltipText} placement="top">
                <div>{styledButtonGroup}</div>
            </Tooltip>
        ) : (
            styledButtonGroup
        )
    }

    const renderButtonGroup = (group) => renderStyledButtonGroup(group)

    const renderButtons = (actionButtons) =>
        actionButtons
            // hide action buttons for the LC Organization account
            .filter(() => Userdata.organization_id !== LEADERSHIP_CONNECT_ORG_ID)
            // do not show sort by button in table view
            .filter((item) => !props.isTableView || item.key !== "sortByButton")
            .map((item) => (!item.buttons ? renderButton(item) : renderButtonGroup(item)))

    const regroupMiddleChildren = () => {
        if (props.groupedActionButtons) {
            if (props.leftGroupedActionButtons) {
                return renderButtons(props.leftGroupedActionButtons.concat(props.groupedActionButtons))
            }

            return renderButtons(props.leftActionButtons.concat(props.groupedActionButtons))
        }

        return renderButtons(props.leftActionButtons.concat(props.actionButtons))
    }

    if (props.isProfile) {
        return (
            <StyledSearchActionButtons
                isProfile
                leftChildren={renderButtons([
                    ...(props.shouldHideFilters ? [ShowFilterSetButton] : []),
                    SearchCountInProfile,
                ])}
                middleChildren={regroupMiddleChildren()}
                rightChildren={renderButtons([SearchProfileInput])}
            />
        )
    }

    return (
        <>
            <StyledSearchActionButtons
                leftChildren={renderButtons(
                    props.shouldHideFilters
                        ? [ShowFilterSetButton].concat(props.leftActionButtons)
                        : props.leftActionButtons,
                )}
                leftChildrenGrouped={
                    props.leftGroupedActionButtons &&
                    renderButtons(
                        props.shouldHideFilters
                            ? [ShowFilterSetButton].concat(props.leftGroupedActionButtons)
                            : props.leftGroupedActionButtons,
                    )
                }
                rightChildren={renderButtons(props.actionButtons)}
                rightChildrenGrouped={props.rightGroupedActionButtons && renderButtons(props.rightGroupedActionButtons)}
            />
            <PayrollFormModal />
        </>
    )
}

SearchActionButtons.propTypes = {
    isProfile: PropTypes.bool,
    isTableView: PropTypes.bool.isRequired,
    isOnlyTableView: PropTypes.bool,
    resource: PropTypes.object.isRequired,
    uniqueFlvId: PropTypes.string.isRequired,

    // from shared/search/containers/FilterableListView/FilterableListViews
    actionButtons: PropTypes.array,
    groupedActionButtons: PropTypes.array,
    leftActionButtons: PropTypes.array,
    leftGroupedActionButtons: PropTypes.array,
    quorumDataType: PropTypes.number.isRequired,
    rightGroupedActionButtons: PropTypes.array,
    shouldHideFilters: PropTypes.bool,
}

SearchActionButtons.defaultProps = {
    actionButtons: [],
    leftActionButtons: [],
}
